"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UNIFIED_ORDER_DATA_ADAPTER = exports.UDS_SPACING_OPTIONS = exports.SUBMISSION_MESSAGE_TYPES = exports.STORYBOOK_MAX_STORY_CASES = exports.STAGING_BASIC_AUTHORIZATION = exports.QUERY_STRING_TOPIC = exports.QUERY_STRING_PROSPECT_ID = exports.QUERY_STRING_PRODUCT = exports.QUERY_STRING_INTERNAL_CAMPAIGN = exports.QUERY_STRING_CAMPAIGN = exports.PROD_DOMAINS = exports.POSTAL_CODE_REGEX_VALIDATION = exports.PHONE_NUMBER_REGEX_VALIDATION = exports.NUMERIC_REGEX_VALIDATION = exports.NON_PROD_KOODO_DOMAINS = exports.NON_PROD_DOMAIN_REVIEW = exports.NON_PROD_DOMAINS = exports.NAME_FIELD_KEYS = exports.LONG_SHORT_ANSWER_REGEX_VALIDATION = exports.LOCAL_DEV_ENVIRONMENT = exports.LETTERS_REGEX_VALIDATION = exports.INPUT_FIELD_TYPE = exports.HTTP_POST = exports.HTTP_GET = exports.HEADER_CONTENT_TYPE_JSON = exports.HEADER_CONTENT_TYPE = exports.HEADER_AUTHORIZATION = exports.HEADER_ACCESS_TOKEN = exports.HEADER_ACCESS_CONFIG_AMS_API_VALUE = exports.HEADER_ACCESS_CONFIG = exports.GKE_DOMAIN = exports.GENERIC_DATA_ADAPTER_TYPE = exports.GCP_PROD_RECAPTCHA_SITE_KEY = exports.GCP_ERROR_REPORTING_PROJECT_ID = exports.GCP_ERROR_REPORTING_API_KEY = exports.GCP_DEV_RECAPTCHA_SITE_KEY = exports.FORM_SPACING_OPTIONS = exports.FORM_SPACING = exports.FORM_API_STAGING = exports.FORM_API_PROD = exports.FORM_API_LOCALHOST = exports.FORM_API_GKE_STAGING = exports.FORM_API_GKE_DEVELOP = exports.FORM_API_ENDPOINT_PATH = exports.FILE_EXTENSIONS = exports.FIELD_WIDTH_OPTIONS = exports.FIELD_WIDTH = exports.FIELD_TYPES = exports.FIELD_HINT_POSITION = exports.FIELD_FEEDBACK = exports.DEVELOP_GKE_DOMAIN = exports.DECIMAL_RADIX = exports.COOKIES_PROV_FALLBACK = exports.COOKIES_PRODUCT_NAME = exports.COOKIES_LANG_FALLBACK = exports.CONTENTFUL_LOCALE = exports.CONTENTFUL = exports.BUTTON_TEXT = exports.APP_ENV = exports.API_VERSION = exports.ANALYTICS_FORM_TYPES = exports.ANALYTICS_ERROR_TYPES = exports.ANALYTICS_ERROR_MESSAGES = exports.ALPHANUMERIC_REGEX_VALIDATION = void 0;
var FORM_API_LOCALHOST = exports.FORM_API_LOCALHOST = 'http://localhost:4000';
var FORM_API_STAGING = exports.FORM_API_STAGING = 'https://www.wcstage.telus.com';
var FORM_API_PROD = exports.FORM_API_PROD = 'https://www.telus.com';
var FORM_API_GKE_STAGING = exports.FORM_API_GKE_STAGING = 'https://form-builder-form-builder-api-staging.np.gke.telus.digital';
var FORM_API_GKE_DEVELOP = exports.FORM_API_GKE_DEVELOP = 'https://form-builder-form-builder-api-develop.np.gke.telus.digital';
var FORM_API_ENDPOINT_PATH = exports.FORM_API_ENDPOINT_PATH = '/form-builder-api';
var GKE_DOMAIN = exports.GKE_DOMAIN = 'np.gke.telus.digital';
var DEVELOP_GKE_DOMAIN = exports.DEVELOP_GKE_DOMAIN = 'develop.np.gke.telus.digital';
var PROD_DOMAINS = exports.PROD_DOMAINS = ['https://www.telus.com', 'https://www.wcpreview.telus.com', 'https://wcpreview.telus.com', 'https://www.koodomobile.com', 'https://preview.www.koodomobile.com', 'https://www.friendlyfuture.com', 'https://publicmobile.ca', 'https://www.publicmobile.ca', 'https://stage.publicmobile.ca',
// This is preview on public mobile
'https://www.stage.publicmobile.ca' // This is preview on public mobile
];
var NON_PROD_DOMAINS = exports.NON_PROD_DOMAINS = ['https://www.wcstage.telus.com', 'https://wcstage.telus.com', 'https://www.wctest.telus.com', 'https://wctest.telus.com'];
var NON_PROD_DOMAIN_REVIEW = exports.NON_PROD_DOMAIN_REVIEW = 'gke.telus.digital';
var NON_PROD_KOODO_DOMAINS = exports.NON_PROD_KOODO_DOMAINS = /^https:\/\/(?!(www|preview)\.)(.*\.)?(koodomobile)\.com/;

// Basic Auth string created by base64 encoding: btoa(`${username}:${password}`)
// Note: this gets rotated monthly and we should find a permanent solution
var STAGING_BASIC_AUTHORIZATION = exports.STAGING_BASIC_AUTHORIZATION = "Basic bWFyYzpyZWdpc2hhbm5haDE5NTY=";
var LOCAL_DEV_ENVIRONMENT = exports.LOCAL_DEV_ENVIRONMENT = 'development';
var HEADER_CONTENT_TYPE = exports.HEADER_CONTENT_TYPE = 'content-type';
var HEADER_CONTENT_TYPE_JSON = exports.HEADER_CONTENT_TYPE_JSON = 'application/json';
var HEADER_ACCESS_TOKEN = exports.HEADER_ACCESS_TOKEN = 'access-token';
var HEADER_ACCESS_CONFIG = exports.HEADER_ACCESS_CONFIG = 'access-config';
var HEADER_AUTHORIZATION = exports.HEADER_AUTHORIZATION = 'authorization';
var API_VERSION = exports.API_VERSION = 'v1';
var HTTP_GET = exports.HTTP_GET = 'GET';
var HTTP_POST = exports.HTTP_POST = 'POST';
var UNIFIED_ORDER_DATA_ADAPTER = exports.UNIFIED_ORDER_DATA_ADAPTER = 'unifiedOrderDataAdapter';
var GENERIC_DATA_ADAPTER_TYPE = exports.GENERIC_DATA_ADAPTER_TYPE = 'genericDataAdapter';
var COOKIES_PROV_FALLBACK = exports.COOKIES_PROV_FALLBACK = 'bc';
var COOKIES_LANG_FALLBACK = exports.COOKIES_LANG_FALLBACK = 'en';
var COOKIES_PRODUCT_NAME = exports.COOKIES_PRODUCT_NAME = 'lastproduct.productName';
var QUERY_STRING_PRODUCT = exports.QUERY_STRING_PRODUCT = 'product';
var QUERY_STRING_CAMPAIGN = exports.QUERY_STRING_CAMPAIGN = 'cmp';
var QUERY_STRING_INTERNAL_CAMPAIGN = exports.QUERY_STRING_INTERNAL_CAMPAIGN = 'intcmp';
var QUERY_STRING_TOPIC = exports.QUERY_STRING_TOPIC = 'topic';
var QUERY_STRING_PROSPECT_ID = exports.QUERY_STRING_PROSPECT_ID = 'p_id';
var CONTENTFUL_LOCALE = exports.CONTENTFUL_LOCALE = {
  en: 'en',
  fr: 'fr',
  enCA: 'en-CA',
  frCA: 'fr-CA'
};
var FIELD_FEEDBACK = exports.FIELD_FEEDBACK = {
  SUCCESS: 'success',
  ERROR: 'error'
};
var FIELD_HINT_POSITION = exports.FIELD_HINT_POSITION = {
  INLINE: 'inline',
  BELOW: 'below'
};
var DECIMAL_RADIX = exports.DECIMAL_RADIX = 10;
var INPUT_FIELD_TYPE = exports.INPUT_FIELD_TYPE = {
  TEXT: 'text',
  EMAIL: 'email',
  NUMBER: 'number',
  PHONE: 'tel'
};
var NAME_FIELD_KEYS = exports.NAME_FIELD_KEYS = {
  FIRST_NAME: 'first',
  LAST_NAME: 'last'
};
var PHONE_NUMBER_REGEX_VALIDATION = exports.PHONE_NUMBER_REGEX_VALIDATION = /^(?:\+1|1)?[2-9]\d{2}[2-9]\d{6}$/;
var POSTAL_CODE_REGEX_VALIDATION = exports.POSTAL_CODE_REGEX_VALIDATION = /^[A-Z]\d[A-Z][ -]?\d[A-Z]\d$/;
var LONG_SHORT_ANSWER_REGEX_VALIDATION = exports.LONG_SHORT_ANSWER_REGEX_VALIDATION = /^[a-zA-Z0-9À-ż(.+_!@,^%#$\s=:|'`‘’?*/&[\];)-]+$/;
var NUMERIC_REGEX_VALIDATION = exports.NUMERIC_REGEX_VALIDATION = /^\d+(\.\d*)?$/;
var LETTERS_REGEX_VALIDATION = exports.LETTERS_REGEX_VALIDATION = /^[a-zA-ZÀ-ż ]{1,}$/;
var ALPHANUMERIC_REGEX_VALIDATION = exports.ALPHANUMERIC_REGEX_VALIDATION = /^[a-zA-ZÀ-ż\d ]{1,}$/;
var FIELD_TYPES = exports.FIELD_TYPES = {
  FORM_CONTENT_TYPE: 'form',
  CHECKBOX_FIELD: 'checkboxField',
  RADIOBUTTON_FIELD: 'radioButtonField',
  DROPDOWNLIST_FIELD: 'dropdownListField',
  NUMBER_FIELD: 'numberField',
  PHONE_NUMBER_FIELD: 'phoneNumberField',
  SHORTANSWER_FIELD: 'shortAnswerField',
  LONGANSWER_FIELD: 'longAnswerField',
  EMAIL_FIELD: 'emailField',
  CONSENT_FIELD: 'consentField',
  ADDRESS_FIELD: 'addressField',
  DATEPICKER_FIELD: 'datePickerField',
  GENESYSTIMESLOTS_FIELD: 'genesysTimeSlotsField',
  FILE_UPLOAD_FIELD: 'fileUploadField',
  RICH_TEXT_FIELD: 'formBuilderRichText',
  FIELD_GROUP_FIELD: 'fieldGroup',
  CONDITIONAL_FIELD: 'conditionalField',
  STEP_TRACKER_FIELD: 'stepTracker',
  STEP_CONTENT_TYPE: 'step'
};
var UDS_SPACING_OPTIONS = exports.UDS_SPACING_OPTIONS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
var FORM_SPACING = exports.FORM_SPACING = {
  COMPACT: 'Compact (24px | UDS 4)',
  DEFAULT: 'Default (32px | UDS 5)',
  LOOSE: 'Loose (40px | UDS 6)'
};
var FORM_SPACING_OPTIONS = exports.FORM_SPACING_OPTIONS = [FORM_SPACING.COMPACT, FORM_SPACING.DEFAULT, FORM_SPACING.LOOSE];
var FIELD_WIDTH = exports.FIELD_WIDTH = {
  DEFAULT: 'Entire row',
  ONE_QUARTER: '1/4 of the row',
  TWO_QUARTERS: '1/2 of the row',
  THREE_QUARTERS: '3/4 of the row'
};
var FIELD_WIDTH_OPTIONS = exports.FIELD_WIDTH_OPTIONS = [FIELD_WIDTH.ONE_QUARTER, FIELD_WIDTH.TWO_QUARTERS, FIELD_WIDTH.THREE_QUARTERS, FIELD_WIDTH.DEFAULT];
var SUBMISSION_MESSAGE_TYPES = exports.SUBMISSION_MESSAGE_TYPES = {
  Message: 'Message',
  Link: 'Link'
};
var BUTTON_TEXT = exports.BUTTON_TEXT = {
  en: {
    back: 'Back',
    continue: 'Continue',
    submit: 'Submit'
  },
  fr: {
    back: 'Retour',
    continue: 'Continuer',
    submit: 'Soumettre'
  }
};
var GCP_PROD_RECAPTCHA_SITE_KEY = exports.GCP_PROD_RECAPTCHA_SITE_KEY = "6LeM5bYkAAAAACJJRgr9FcnVmovh4DU8FvkSBgfV";
var GCP_DEV_RECAPTCHA_SITE_KEY = exports.GCP_DEV_RECAPTCHA_SITE_KEY = "6LcxMbckAAAAABV9R0R_c33dp_cMkbPz6y-UfUmc";

// stack driver error reporting - Development/Staging/Test/Preview environment
var GCP_ERROR_REPORTING_API_KEY = exports.GCP_ERROR_REPORTING_API_KEY = "AIzaSyBOUQ9xxYc6NDqo4FN_4uPQtZ3PNORcQ6s";
var GCP_ERROR_REPORTING_PROJECT_ID = exports.GCP_ERROR_REPORTING_PROJECT_ID = "form-builder-73f01128";

//env
var APP_ENV = exports.APP_ENV = "production";

// AMS API End-Point access-config value
var HEADER_ACCESS_CONFIG_AMS_API_VALUE = exports.HEADER_ACCESS_CONFIG_AMS_API_VALUE = 'fb2';
var STORYBOOK_MAX_STORY_CASES = exports.STORYBOOK_MAX_STORY_CASES = 500;
var ANALYTICS_ERROR_TYPES = exports.ANALYTICS_ERROR_TYPES = {
  FIELD_COMPLETION: 'consumer_failed_to_complete_all_fields',
  SUBMISSION: 'formBuilder_failed_to_send_submission',
  FORM_LOAD: 'pageLoaded_error_form_builder_form_did_not_load',
  PREFILLED: 'prefill_values_were_not_successfully_passed'
};
var ANALYTICS_FORM_TYPES = exports.ANALYTICS_FORM_TYPES = {
  LEAD: 'lead',
  FORM: 'form'
};
var ANALYTICS_ERROR_MESSAGES = exports.ANALYTICS_ERROR_MESSAGES = {
  MISSING_CONTENTFUL_DATA: "Analytics settings error: please review analytics fields for this entry"
};
var CONTENTFUL = exports.CONTENTFUL = {
  SPACES: {
    SB2: {
      NAME: 'sb2',
      ENVIRONMENTS: {
        STAGING: 'staging',
        SANDBOX: 'sandbox',
        MASTER: 'master'
      }
    }
  }
};
var FILE_EXTENSIONS = exports.FILE_EXTENSIONS = {
  IMAGES: ['jpg', 'jpeg', 'png'],
  DOCS: ['doc', 'docx', 'xls', 'xlsx'],
  PDF: ['pdf']
};
var constantFields = {
  FORM_API_LOCALHOST,
  FORM_API_ENDPOINT_PATH,
  HEADER_CONTENT_TYPE,
  HEADER_CONTENT_TYPE_JSON,
  HEADER_ACCESS_TOKEN,
  HEADER_ACCESS_CONFIG,
  HEADER_AUTHORIZATION,
  STAGING_BASIC_AUTHORIZATION,
  LOCAL_DEV_ENVIRONMENT,
  API_VERSION,
  HTTP_GET,
  HTTP_POST,
  UNIFIED_ORDER_DATA_ADAPTER,
  COOKIES_PROV_FALLBACK,
  COOKIES_LANG_FALLBACK,
  COOKIES_PRODUCT_NAME,
  QUERY_STRING_PRODUCT,
  QUERY_STRING_CAMPAIGN,
  QUERY_STRING_INTERNAL_CAMPAIGN,
  QUERY_STRING_TOPIC,
  CONTENTFUL_LOCALE,
  FIELD_FEEDBACK,
  FIELD_HINT_POSITION,
  DECIMAL_RADIX,
  INPUT_FIELD_TYPE,
  NAME_FIELD_KEYS,
  FIELD_TYPES,
  GCP_PROD_RECAPTCHA_SITE_KEY,
  GCP_DEV_RECAPTCHA_SITE_KEY,
  GCP_ERROR_REPORTING_API_KEY,
  GCP_ERROR_REPORTING_PROJECT_ID,
  APP_ENV,
  HEADER_ACCESS_CONFIG_AMS_API_VALUE,
  STORYBOOK_MAX_STORY_CASES,
  ANALYTICS_ERROR_TYPES,
  ANALYTICS_FORM_TYPES,
  FORM_SPACING
};
var _default = exports.default = constantFields;